'use client';

import { FC } from 'react';
import { useOrgContext } from '@provider-directory/components/org-context/org-context-provider';
import {
  getProviderAvailableInsurances,
  getProviderAvailableInsurancesOverrideByOrg,
  InsuranceResolutionContext,
} from '@provider-directory/models/insurance.model';
import { InsuranceCarrier } from '@provider-directory/types';
import {
  ProviderDetailsResource,
  ProviderSpecialtyResource,
  Status,
} from '@provider-directory/types/providers.contracts';
import { InsuranceCarrierList } from './insurance-carrier-list.component';

interface InsuranceListProps {
  hospitalAssociations: ProviderDetailsResource['hospitalAssociations'];
  specialties: ProviderSpecialtyResource[];
  status: Status | null;
}

export const InsuranceList: FC<InsuranceListProps> = ({
  hospitalAssociations,
  specialties,
  status,
}) => {
  const { key, runtimeConfig } = useOrgContext();

  const resolutionContext: InsuranceResolutionContext = {
    hospitalAssociationMapping: runtimeConfig.hospitalAssociationMapping,
    insuranceResolutionRule: runtimeConfig.insuranceResolutionRule,
    insurance: runtimeConfig.insurance,
    fallbackKey: key,
  };

  const overrideCarriers = getProviderAvailableInsurancesOverrideByOrg(
    hospitalAssociations,
    specialties,
    status,
    resolutionContext,
  );

  const carriers =
    overrideCarriers ??
    getProviderAvailableInsurances(hospitalAssociations, resolutionContext)
      .sort()
      .map((name): InsuranceCarrier => ({ name }));

  return <InsuranceCarrierList carriers={carriers} />;
};
